import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  LinearProgress,
  CircularProgress,
  IconButton,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const FormEditUser = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [image, setImage] = useState(data?.photo);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errorMessage && name === "password") {
      if (value === data.password_confirmation) setErrorMessage();
    }
    if (errorMessage && name === "password_confirmation") {
      if (value === data.password) setErrorMessage();
    }
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (data.password !== data.password_confirmation) {
      setErrorMessage(
        "Passwords do not match! Please ensure both passwords are the same."
      );
      return;
    }

    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Put({
        url: api_Routes.Users.Edit + id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Users");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Email"
          name="email"
          required
          type="email"
          autoComplete="off"
          value={data.email}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
        <div className="mt-3 mb-3">
          <FormControl className="w-full mt-4 mb-2" variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              fullWidth
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showPassword
                        ? "hide the password"
                        : "display the password"
                    }
                    onClick={handleClickShowPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
              name="password"
              autoComplete="off"
              value={data.password}
              onChange={handleInputChange}
              variant="outlined"
            />
          </FormControl>
        </div>

        <div className="mt-4 mb-3">
          <FormControl className="w-full" variant="outlined">
            <InputLabel htmlFor="outlined-adornment-confirm-password">
              Confirm password
            </InputLabel>
            <OutlinedInput
              fullWidth
              margin="normal"
              id="outlined-adornment-confirm-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showPassword
                        ? "hide the password"
                        : "display the password"
                    }
                    onClick={handleClickShowPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Confirm password"
              name="password_confirmation"
              autoComplete="off"
              value={data.password_confirmation}
              onChange={handleInputChange}
              variant="outlined"
            />
          </FormControl>
        </div>
      </div>
      {errorMessage && (
        <div className="w-full text-start text-red-600">*{errorMessage}</div>
      )}

      <div className="flex items-center justify-between gap-x-3">
        <div className="flex items-center justify-start gap-x-3">
          <FormLabel sx={{ fontWeight: "bold" }} component="legend">
            Active:
          </FormLabel>
          <RadioGroup
            name="active"
            value={data.active}
            onChange={handleRadioChange}
            row
          >
            <FormControlLabel value="1" control={<Radio />} label="Yes" />
            <FormControlLabel value="0" control={<Radio />} label="No" />
          </RadioGroup>
        </div>
        <div className="flex items-center justify-start gap-x-3">
          <FormLabel sx={{ fontWeight: "bold" }} component="legend">
            Is email verified?
          </FormLabel>
          <RadioGroup
            name="email_verified"
            value={data.email_verified}
            onChange={handleRadioChange}
            row
          >
            <FormControlLabel value={1} control={<Radio />} label="Yes" />
            <FormControlLabel value={0} control={<Radio />} label="No" />
          </RadioGroup>
        </div>
      </div>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit || errorMessage}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
